<script>
   /*************************************************************/
   /* Svelte component for showing app plots                    */
   /*************************************************************/

   // import plot and plot controls components
   import { DistancePlot, DistancePlotControls } from './plots';
   import { ScoresPlot, ScoresPlotControls } from './plots';
   import { VariancePlot, VariancePlotControls } from './plots';
   import { RMSEPlot, RMSEPlotControls } from './plots';
   import { PredictionsPlot, PredictionsPlotControls } from './plots';
   import { ScalarsPlot, ScalarsPlotControls } from './plots';

   // Input parameters
   export let model;
   export let res;
   export let scalars;
   export let pvoptions;

   // selected plot number and its parameters
   let selected_plot = 0;
   let params = null;

   // array with list of plots and their components
   const options = [
      {label: 'Scalars', plotComponent: ScalarsPlot, controlsComponent: ScalarsPlotControls},
      {label: 'RMSE', plotComponent: RMSEPlot, controlsComponent: RMSEPlotControls},
      {label: 'Predictions', plotComponent: PredictionsPlot, controlsComponent: PredictionsPlotControls},
      {label: 'Variance', plotComponent: VariancePlot, controlsComponent: VariancePlotControls},
      {label: 'Scores', plotComponent: ScoresPlot, controlsComponent: ScoresPlotControls},
      {label: 'Distance', plotComponent: DistancePlot, controlsComponent: DistancePlotControls}
   ]

   // function to switch between plots
   function switchPlot(i) {
      params = null;
      selected_plot = i;
   }
</script>

<div class="plot-container">

   <!-- column with current plot -->
   <div class="plot-area">
      {#if options[selected_plot].label === 'Scalars'}
      <svelte:component this={options[selected_plot].plotComponent} {scalars} {params}  />
      {:else}
      <svelte:component this={options[selected_plot].plotComponent} {model} {pvoptions} {res} {params}  />
      {/if}
   </div>

   <!-- column with plot selectors and current plot settings -->
   <div class="plot-controls-area">
      {#each options as {label, plotComponent, controlsComponent}, i}
         {#if selected_plot === i}
         <svelte:component this={controlsComponent} bind:params={params} {model} {pvoptions} {res} />
         {:else}
         <button class="plot-selector" on:keydown={() => switchPlot(i)} on:click={() => switchPlot(i)}>{label}</button>
         {/if}
      {/each}
   </div>

</div>


<style>
   .plot-container {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 0;
      display: grid;
      grid-template-rows: 1fr;
      grid-template-columns: 1fr minmax(270px, 30%);
   }

   .plot-area {
      padding: 1em;
      margin-top: 0.25rem;
      border-radius: 0.25em;
      background: #fefefe;
   }

   .plot-controls-area {
      padding: 0 0.25em 0 0.5em;
   }

   .plot-selector {
      cursor: pointer;
      color: #606060;
      background: #fffef480;
      box-sizing: border-box;
      padding: 0.5em 1em;
      margin: 0.25em 0;
      border-radius: 0.25rem;
      box-shadow: none;
      border: none;
      width: 100%;
      text-align: left;
      font-size: 1rem;
   }

   .plot-selector:hover {
      background: #e0e0e0;
      color: #403020;
   }

   @media(min-width:1100px) {
      .plot-container {
         grid-template-columns: 1fr minmax(285px, 30%);
      }
   }

   @media(min-width:1300px) {
      .plot-container {
         grid-template-columns: 1fr minmax(300px, 30%);
      }
   }

</style>